document.addEventListener('DOMContentLoaded', function () {
    let activeTooltip = null;
    
    function positionTooltip(wrapper) {
        const content = wrapper.querySelector('.tooltip-content');
        if (!content) return;
        
        const BUFFER = 55;
        
        // Reset directions
        wrapper.classList.remove('tooltip-dir-top', 'tooltip-dir-bottom', 'tooltip-dir-left', 'tooltip-dir-right');
        
        // Default = TOP
        wrapper.classList.add('tooltip-dir-top');
        
        // Force render for measurement
        content.style.visibility = 'hidden';
        content.style.display = 'block';
        content.getBoundingClientRect();
        
        const rect = content.getBoundingClientRect();
        const vw = window.innerWidth;
        const vh = window.innerHeight;
        
        const fitsTop = rect.top >= BUFFER;
        const fitsBottom = vh - rect.bottom >= BUFFER;
        const fitsLeft = rect.left >= BUFFER;
        const fitsRight = vw - rect.right >= BUFFER;
        
        /* ----------------------------------
        1. Vertical priority
        ---------------------------------- */
        if (fitsTop) {
            wrapper.classList.add('tooltip-dir-top');
        } else if (fitsBottom) {
            wrapper.classList.replace('tooltip-dir-top', 'tooltip-dir-bottom');
        }
        /* ----------------------------------
        2. Horizontal fallback ONLY if needed
        ---------------------------------- */
        else if (fitsRight) {
            wrapper.classList.replace('tooltip-dir-top', 'tooltip-dir-right');
        } else if (fitsLeft) {
            wrapper.classList.replace('tooltip-dir-top', 'tooltip-dir-left');
        }
        
        // Cleanup
        content.style.display = '';
        content.style.visibility = '';
    }

    
    document.querySelectorAll('.tooltip-wrapper.tooltip-dir-auto').forEach(wrapper => {
        const content = wrapper.querySelector('.tooltip-content');
        if (!content) return;
        
        wrapper.addEventListener('mouseenter', () => {
            activeTooltip = wrapper;
            positionTooltip(wrapper);
        });
        
        wrapper.addEventListener('mouseleave', () => {
            activeTooltip = null;
        });
    });
    
    // Recalculate on scroll & resize
    window.addEventListener('scroll', () => {
        if (activeTooltip) {
            positionTooltip(activeTooltip);
        }
    }, { passive: true });
    
    window.addEventListener('resize', () => {
        if (activeTooltip) {
            positionTooltip(activeTooltip);
        }
    });
});